import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import StockMovements from "./StockMovements";
import { BusinessUniteContext } from "../../components/layout/Layout";
import styles from "./StockMovementsWithTabs.module.scss";

const StockMovementsWithTabs: React.FC = () => {
  const { t } = useTranslation();
  const { contextValue: businessUnitSelected } =
    useContext(BusinessUniteContext);

  if (!businessUnitSelected) {
    return (
      <div className={styles.container}>
        <div className={styles.noBusinessUnit}>
          {t("Common-SelectBusinessUnit")}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <StockMovements />
    </div>
  );
};

export default StockMovementsWithTabs;
